export { Idle } from './idle';
export { NotIdle } from './not-idle';
//# sourceMappingURL=/home/travis/build/harunurhan/idlejs/src/index.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/idlejs/dist/index.js
// module id = ../../../../idlejs/dist/index.js
// module chunks = 4